import React from "react";
import irisLogoSrc from "../../assets/images/iris_logo.png";

export const IrisLogo = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <img
    src={irisLogoSrc}
    alt="Iris"
    width={width}
    height={height}
    style={{ display: "block" }}
  />
);
